import React, { Suspense } from "react";
import { useParams } from "react-router-dom";
import CustomLoading from "../Components/GeneralComponents/CustomLoading/customloading";
import { useLocalePath } from "../contexts/LocalePathContext";
import HotelProfilePublicLegacyRedirect from "./HotelProfilePublicLegacyRedirect";

const HotelProfile = React.lazy(() => import("../Pages/Client/HotelProfile/hotelprofile"));

/**
 * Public locale-prefixed hotel profile entry:
 * - he → legacy public profile (RTL)
 * - en/el → redirect to agent dashboard profile route
 */
export function HotelProfilePublicRouteEntry({ handleHotelName }) {
  const { localePrefix } = useLocalePath();
  const { hotelid } = useParams();

  if (localePrefix === "en" || localePrefix === "el") {
    return <HotelProfilePublicLegacyRedirect />;
  }

  return (
    <Suspense fallback={<CustomLoading label="טוען חבילות / חדרים..." overlay size="large" />}>
      <HotelProfile handleHotelName={handleHotelName} key={hotelid} />
    </Suspense>
  );
}

export default HotelProfilePublicRouteEntry;
